/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureDevOpsProject {
    getFixupPrototypeFunction() { return AzureDevOpsProject.fixupPrototype; }

    static newInstance(model: Partial<AzureDevOpsProject>): AzureDevOpsProject {
        let obj = Object.assign(new AzureDevOpsProject(), model);
        AzureDevOpsProject.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureDevOpsProject>): AzureDevOpsProject {
        if (!model) return null;
        return AzureDevOpsProject.newInstance(<AzureDevOpsProject> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureDevOpsProject) {
        if (!obj) return;

        models.AzureDevOpsProject.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureDevOpsProject): boolean {
        Object.setPrototypeOf(obj, AzureDevOpsProject.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Azure DevOps Project Name
     */
    project_name: string;

    /**
     * Azure DevOps Project ID
     */
    project_id: string;

}
